import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	zIndex: {
		modal: 2000,
		snackbar: 2000,
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 640,
			md: 1024,
			lg: 1366,
			xl: 1920,
		},
	},
	palette: {
		text: {
			primary: "#000000",
			secondary: "#666666",
			disabled: "#C7C7C7",
		},
		divider: "#D3DCEC",
		error: {
			main: "#A74343",
			light: "#F07874",
		},
		warning: {
			main: "#FF9B04",
			light: "#FFD179",
		},
		info: { main: "#5566E0", light: "#D7F3FF" },
		background: {
			default: "#F5F6FA",
			paper: "#FFFFFF",
		},
		primary: {
			main: "#5566E0",
			light: "#5566E0",
			dark: "#5566E0",
		},
		success: {
			main: "#459D1C",
			light: "#92DDB9",
		},
		secondary: {
			main: "#666666",
			light: "#54AE35",
			dark: "#EC1D23",
			contrastText: "#B3C0D9",
		},
		violet: {
			main: "#7E92B6",
		},
	},
	typography: {
		fontSize: 15,
		fontFamily: "Ubuntu",
		button: {
			fontSize: 16,
			fontWeight: 500,
		},

		h1: {
			fontSize: 26,
			marginTop: 0,
			fontWeight: 500,
		},
		subtitle1: {
			fontWeight: 400,
			fontSize: 12,
		},
		subtitle2: {
			fontWeight: 500,
			fontSize: 36,
		},

		h2: {
			fontSize: 18,
			fontWeight: 500,
			marginTop: 0,
		},
		h3: {
			fontSize: 16,
			fontWeight: 500,
			marginTop: 0,
		},
		h4: {
			fontSize: 14,
			fontWeight: 500,
			marginTop: 0,
		},
		h5: {
			fontSize: 15,
			fontWeight: 500,
			marginTop: 0,
		},

		body1: {
			color: "#000",
			fontSize: 14,
			fontWeight: 400,
		},
		body2: {
			color: "#000",
			fontSize: 14,
			fontWeight: 400,
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "unset",
				},
			},
		},
	},
});

export default theme;
